// material ui icons
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';

// material ui
import { Chip } from '@mui/material';

interface DeviceTagChipProps {
  label: string;
}

const DeviceTagChip = ({ label }: DeviceTagChipProps) => {
  return (
    <Chip
      icon={<LocalOfferRoundedIcon fontSize="small" />}
      label={label}
      size="small"
      sx={{
        borderRadius: 1,
        backgroundColor: 'info.main',
        color: '#fff',
        '& .MuiChip-icon': {
          color: '#fff',
        },
      }}
    />
  );
};

export default DeviceTagChip;
